'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var slicedToArray = require('../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js');

var React = require('react');

var index = require('../../node_modules/classnames/index.js');

require('../../node_modules/prop-types/index.js');

var NavMobile = require('./NavMobile/NavMobile.js');

var NavPrimary = require('./NavPrimary/NavPrimary.js');

var NavPrimaryDropdown = require('./NavPrimaryDropdown/NavPrimaryDropdown.js');

var NavQuickLink = require('./NavQuickLink/NavQuickLink.js');

var SearchBar = require('../../composites/SearchBar/SearchBar.js');

var useMobileBool = require('../../utilities/hooks/useMobileBool.js');

var lanl_logo_inline = require('../../assets/svg/lanl_logo.inline.svg.js');

var hamburger_inline = require('../../assets/svg/hamburger.inline.svg.js');

var close_inline = require('../../assets/svg/close.inline.svg.js');

var mockData = require('./mockData.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var NavHeader = function NavHeader() {
  var primaryNavData = mockData['default'].primaryNavData,
      quickLinksNavData = mockData['default'].quickLinksNavData;
  var isMobile = useMobileBool.useMobileBool();

  var _useState = React.useState(null),
      _useState2 = slicedToArray['default'](_useState, 2),
      activeNavItem = _useState2[0],
      setActiveNavItem = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = slicedToArray['default'](_useState3, 2),
      searchIsActive = _useState4[0],
      setSearchIsActive = _useState4[1];

  var navheaderClasses = index['default']('navheader', 'lanl-navheader');
  var navwrapperClasses = index['default']('main-nav-wrapper', searchIsActive ? 'search-active' : '');

  if (isMobile) {
    return /*#__PURE__*/React__default['default'].createElement("div", {
      "data-testid": "lanl-navheader",
      className: navheaderClasses
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: navwrapperClasses
    }, /*#__PURE__*/React__default['default'].createElement("a", {
      href: "https://www.lanl.gov",
      "aria-label": "lanl logo"
    }, /*#__PURE__*/React__default['default'].createElement(lanl_logo_inline['default'], {
      className: "lanl-navheader-lanl-logo"
    })), activeNavItem ? /*#__PURE__*/React__default['default'].createElement(close_inline['default'], {
      className: "lanl-mobile-close-icon",
      onClick: function onClick() {
        return setActiveNavItem(null);
      }
    }) : /*#__PURE__*/React__default['default'].createElement(hamburger_inline['default'], {
      onClick: function onClick() {
        return setActiveNavItem('mobile');
      }
    })), /*#__PURE__*/React__default['default'].createElement(NavMobile.NavMobile, {
      activeNavItem: activeNavItem,
      navData: mockData['default']
    }));
  } else {
    return /*#__PURE__*/React__default['default'].createElement("div", {
      "data-testid": "lanl-navheader",
      className: navheaderClasses
    }, /*#__PURE__*/React__default['default'].createElement(NavQuickLink.NavQuickLink, {
      quickLinksNavData: quickLinksNavData
    }), /*#__PURE__*/React__default['default'].createElement("div", {
      className: navwrapperClasses
    }, /*#__PURE__*/React__default['default'].createElement("a", {
      href: "https://www.lanl.gov",
      "aria-label": "lanl logo"
    }, /*#__PURE__*/React__default['default'].createElement(lanl_logo_inline['default'], {
      className: "lanl-navheader-lanl-logo"
    })), /*#__PURE__*/React__default['default'].createElement(NavPrimary.NavPrimary, {
      primaryNavData: primaryNavData,
      activeNavItem: activeNavItem,
      setActiveItemCb: setActiveNavItem,
      searchIsActive: searchIsActive
    }), /*#__PURE__*/React__default['default'].createElement(SearchBar.SearchBar, {
      active: searchIsActive,
      setSearchIsActive: setSearchIsActive
    })), /*#__PURE__*/React__default['default'].createElement(NavPrimaryDropdown.NavPrimaryDropdown, {
      activeNavItem: activeNavItem,
      primaryNavData: primaryNavData
    }));
  }
};

NavHeader.defaultProps = {};
NavHeader.propTypes = {};
exports.NavHeader = NavHeader;
exports['default'] = NavHeader;